<template>
  <div>
    <div class="tile is-parent pl-1">
      <article class="tile is-child box">
        <div class="columns is-flex is-align-items-center">
          <div class="column">
            <div class="is-flex is-align-items-center">
              <div v-if="entity"
                class="field mb-0">
                <div class="control">
                  <input
                    v-model="entity.modDesc"
                    @input="onModDescChange"
                    type="text"
                    class="input is-size-4 has-text-weight-semibold"
                    :class="{ 'is-danger': $vv && $vv.entity && $vv.entity.modDesc && $vv.entity.modDesc.$error }"
                    style="max-width: 26rem;"
                    placeholder="FlexiQuote Module">
                </div>
                <p v-if="$vv && $vv.entity && $vv.entity.modDesc && $vv.entity.modDesc.$error"
                  class="help is-danger">Module description is required</p>
              </div>
              <span v-else
                class="title">FlexiQuote Module</span>
              <span v-if="entity && entity.isBase"
                class="tag is-success ml-2">Base Module</span>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <PermissionTree :permission-records="permissionRecords"
              :disable-toggle-children="true" />
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import PermissionTree from '../components/PermissionTree.vue'
import SystemModuleService from '../systemmodule/systemModuleService'

export default {
  name: 'FlexiquoteModuleDetail',
  inject: {
    $vv: {
      default: null
    }
  },
  components: {
    PermissionTree
  },
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showAccessibleItems: true,
      permissionRecords: [],
      isResetting: false,
      selectedModulePermissionRecords: []
    }
  },
  computed: {
    entity: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    permissionRecords: {
      handler: function () {
        if (this.isResetting) return
        this.syncPermissionRecordsToEntity()
      },
      deep: true
    },
    '$route.params.moduleId': {
      async handler(newModuleId, oldModuleId) {
        if (newModuleId && newModuleId !== oldModuleId) {
          this.$showSpinner()
          await this.loadModuleData()
          this.$hideSpinner()
        }
      }
    }
  },
  async created() {
    this.$showSpinner()
    await this.loadModuleData()
    this.$hideSpinner()
  },
  methods: {
    onModDescChange() {
      this.$emit('input', this.entity)
    },
    syncPermissionRecordsToEntity() {
      if (!this.entity) return
      const activeRecords = this.permissionRecords
        .filter(record => record.active)
        .map(record => ({
          permissionRecordId: record.permissionRecordID,
          name: record.name
        }))
      this.entity.permissionRecords = activeRecords
      this.$emit('input', this.entity)
    },
    async loadModuleData() {
      if (!this.entity) return

      if (this.entity.isNew) {
        const allRecords = await SystemModuleService.getAllPermissionRecords()
        const mergedRecords = allRecords.map((record) => {
          return {
            ...record,
            active: false
          }
        })

        this.isResetting = true
        this.permissionRecords = mergedRecords
        this.disableNodePermissionAndChildren('Accounts')

        await this.$nextTick()
        this.isResetting = false
        return
      }

      const allRecords = await SystemModuleService.getAllPermissionRecords()
      this.selectedModulePermissionRecords = this.entity.permissionRecords || []
      const selectedPermissionIds = new Set(this.selectedModulePermissionRecords.map((p) => p.permissionRecordId))
      const mergedRecords = allRecords.map((record) => {
        return {
          ...record,
          active: selectedPermissionIds.has(record.permissionRecordID)
        }
      })

      this.isResetting = true
      this.permissionRecords = mergedRecords
      this.disableNodePermissionAndChildren('Accounts')

      await this.$nextTick()
      this.isResetting = false
    },
    disableNodePermissionAndChildren(nodeName) {
      const parentNode = this.permissionRecords.find(
        record => record.name === nodeName
      )
      if (!parentNode) {
        return
      }
      const disableRecordAndChildren = (parentId) => {
        const children = this.permissionRecords.filter(
          record => record.parentID === parentId
        )

        children.forEach(child => {
          this.$set(child, 'disabled', true)
          disableRecordAndChildren(child.permissionRecordID)
        })
      }
      this.$set(parentNode, 'disabled', true)
      disableRecordAndChildren(parentNode.permissionRecordID)
    }
  }
}
</script>

<style scoped>
</style>
